// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

import { combineReducers } from 'redux';
import { ActionTypes } from 'utils/constants.jsx';

function getConferencesRequest(state = false, action) {
    switch (action.type) {
        case ActionTypes.GET_CONFERENCES_REQUEST_STATUS:
            return action.state;
        default:
            return state;
    }
}

export default combineReducers({
    getConferencesRequest
});
